import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadge = () => {
  return (
    <div className="flex items-center justify-center gap-6 pt-6 border-t border-border">
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 bg-success/10 rounded-full flex items-center justify-center">
          <Icon name="Shield" size={16} className="text-success" />
        </div>
        <div className="text-left">
          <p className="text-xs font-medium text-text-primary">SSL Secured</p>
          <p className="text-xs text-text-secondary">256-bit encryption</p>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
          <Icon name="Lock" size={16} className="text-primary" />
        </div>
        <div className="text-left">
          <p className="text-xs font-medium text-text-primary">Protected</p>
          <p className="text-xs text-text-secondary">Secure access</p>
        </div>
      </div>
    </div>
  );
};

export default SecurityBadge;